import request from './fetcher/request'
/**
 * @typedef {Object} RequestParams
 * @property {String} batch
 * @property {String} frm
 * @property {number} install_days
 */

/**
 * 验证是否有效权益会员
 * @param {RequestParams} data
 */
function validSubVip (data) {
  return request.post('/api/sdk/subvip/pop/valid', data)
}

/**
 * 激活权益
 * @param {RequestParams} data
 */
function activeSubVip (data) {
  return request.post('/api/sdk/subvip/pop/active', data)
}

/**
 * 领取一天免费会员权益
 */
export async function getOneDayFreeVip () {
  try {
    const { resp_common: valid_resp } = await validSubVip({
      batch: '14',
      frm: 'jgpdf_login_xunlei'
    })
    if (valid_resp.ret !== 0) {
      throw valid_resp.msg
    }
    const { resp_common: activeResult } = await activeSubVip({
      batch: '14',
      frm: 'jgpdf_login_xunlei'
    })
    if (activeResult.ret !== 0) {
      throw activeResult.msg
    }
    console.log('领取一天免费会员权益成功')
  } catch (error) {
    console.log('领取一天免费会员权益失败:', error)
  }
}
